import { useBackButtonBehaviour } from './useBackButtonBehaviour';

const goBack = (): void => window.history.back();

export function useHistoryGoBackBehaviour(): void {
  useBackButtonBehaviour(goBack);
}
